module.exports = __webpack_public_path__ + "img/Barakov.3e226a4d.png";